import React from 'react';
import {
  Row,
  Col,
  Modal,
  Spin,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { SpText } from '../../../../../components/DesignKit';

type Props = {
  statusModalMessage: String,
  messageModalVisible: Boolean,
};

const QuickPayMessageModal = (props: Props) => {
  const {
    statusModalMessage,
    messageModalVisible,
  } = props;

  return (
    <Modal
      open={messageModalVisible}
      closable={false}
      footer={null}
    >
      {statusModalMessage === 'orderProcessing' && (
        <Row type="flex" justify="space-between justify-content-center">
          <Col span={24} className="d-flex justify-content-center align-items-center mb-3">
            <Spin />
          </Col>
          <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
            <SpText fontSize='18px' color="#000000" fontWeight="500">Processing your order</SpText>
          </Col>
        </Row>
      )}
      {statusModalMessage === 'failed' && (
        <Row type="flex" justify="space-between justify-content-center">
          <Col span={24} className="d-flex justify-content-center align-items-center mb-3">
            <ExclamationCircleOutlined style={{ color: 'red', fontSize: '36px' }} />
          </Col>
          <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
            <SpText fontSize='18px' color="red" fontWeight="500">Unable to place your order</SpText>
          </Col>
        </Row>
      )}
      {statusModalMessage === 'notEnoughStock' && (
        <Row type="flex" justify="space-between justify-content-center">
          <Col span={24} className="d-flex justify-content-center align-items-center mb-3">
            <ExclamationCircleOutlined style={{ color: 'red', fontSize: '36px' }} />
          </Col>
          <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
            <SpText fontSize='18px' color="red" fontWeight="500">Not Enough Stock</SpText>
          </Col>
        </Row>
      )}
      {statusModalMessage === 'processing' && (
        <Row type="flex" justify="space-between justify-content-center">
          <Col span={24} className="d-flex justify-content-center align-items-center mb-3">
            <Spin />
          </Col>
          <Col span={24} className="d-flex justify-content-center align-items-center mb-2">
            <SpText fontSize='18px' color="#000000" fontWeight="500">Processing your order</SpText>
          </Col>
        </Row>
      )}
    </Modal>
  );
};

export default QuickPayMessageModal;
